import { type ThunkAction } from 'redux-thunk';
import { type ActionType } from 'typesafe-actions';

import { RequestStatus } from '../../../../models';
import * as api from '../../api';
import type RootState from '../RootState';

import * as actions from './actions';

type Actions = ActionType<typeof actions>;
type MfaPromptThunkAction<ReturnType> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Actions
>;

/** Orchestrates the retrieval of available factors, updating status in the store */
// eslint-disable-next-line import/prefer-default-export -- follow nav thunks pattern
export const requestAvailableFactors =
  (): MfaPromptThunkAction<void> => async (dispatch, getState) => {
    const { mfaPrompt: state } = getState();

    if (state.availableFactorsStatus === RequestStatus.Pending) {
      return;
    }

    dispatch(actions.availableFactorsRequested());

    try {
      const factors = await api.readAvailableFactors();

      if (factors.length === 0) {
        dispatch(actions.availableFactorsNotReceived());

        return;
      }

      dispatch(actions.availableFactorsReceived(factors));
    } catch (e) {
      dispatch(actions.availableFactorsNotReceived());
    }
  };

export const requestProtectedUrls =
  (): MfaPromptThunkAction<void> => async (dispatch, getState) => {
    const { mfaPrompt: state } = getState();

    if (state.protectedUrlsStatus === RequestStatus.Pending) {
      return;
    }

    dispatch(actions.protectedUrlsRequested());

    try {
      const protectedUrls = await api.getProtectedUrls();

      dispatch(actions.protectedUrlsReceived(protectedUrls));
    } catch (e) {
      dispatch(actions.protectedUrlsNotReceived());
    }
  };
